<template>
  <div class="join-container">
    <div
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between"
    >
      <div class="col text-center">
        <img
          class="mx-auto d-block pt-4 logo-image"
          v-if="studio.logo"
          :src="studio.logo.thumbnail"
        />
        <div>
          <div class="h1 pt-md-4 py-2">{{ $t('STUDIO.TITLE.OPT_IN') }}</div>
          <div class="pt-md-2">
            {{ $t('STUDIO.TEXT.OPT_IN_WE_WOULD_LOVE_IT') }}
          </div>
          <HMButton
            v-if="isLoggedIn"
            color="brand"
            class="my-md-4 my-3"
            :loading="isLoading"
            @click="optIn()"
            >{{ $t('STUDIO.BUTTON.OPT_IN') }}
          </HMButton>
          <p v-else>
            {{ $t('GENERAL.TEXT.LOG_IN_TO_CONTINUE') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import { getStudioURL } from '../../router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioOptIn',
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      user: 'user/user',
      isLoggedIn: 'user/isLoggedIn',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    optIn() {
      this.joinStudio();
    },
    async joinStudio() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('studio/optInToStudioMarketing', {
          studioURL: this.studioURL,
          optIn: true,
        });
        this.$router.push({ name: 'studio-home' });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
      await this.$store.dispatch('studio/getStudio', this.studioURL);
      this.isLoading = false;
    },
  },
  mounted() {
    this.$store.dispatch('user/meStudent');
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.logo-image {
  max-width: 100%;
  padding: 0 1rem 1rem 1rem;
  max-height: 150px;
}
.join-container {
  padding-top: 8rem;
}
</style>
